import { Empty } from "@/components/root/empty";

export const Subscriptions = () => {
    return <Empty />;
};
